import { useVirtualizer } from '@tanstack/react-virtual';
import React, { useLayoutEffect, useRef, useState } from 'react';
export default function VirtualizedListItems(props) {
    var _a;
    const enabled = ((_a = props.optionCount) !== null && _a !== void 0 ? _a : props.items.length) > 500;
    const contentRef = useRef(null);
    const [scrollMargin, setScrollMargin] = useState(0);
    const virtualizer = useVirtualizer({
        count: props.items.length,
        enabled,
        getScrollElement: () => props.scrollRef.current,
        getItemKey: props.getItemKey,
        estimateSize: () => 48,
        overscan: 5,
        scrollMargin,
    });
    // The sticky list header is outside the virtual rows and can change height during search.
    useLayoutEffect(() => {
        var _a, _b;
        setScrollMargin((_b = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) !== null && _b !== void 0 ? _b : 0);
    });
    useLayoutEffect(() => {
        if (props.scrollRef.current)
            props.scrollRef.current.scrollTop = 0;
    }, [props.resetKey]);
    useLayoutEffect(() => {
        const scrollElement = props.scrollRef.current;
        if (!enabled || !scrollElement || typeof ResizeObserver === 'undefined')
            return;
        let width = scrollElement.clientWidth;
        const observer = new ResizeObserver(() => {
            var _a;
            if (width !== scrollElement.clientWidth) {
                width = scrollElement.clientWidth;
                virtualizer.measure();
                // Existing keyed rows keep their refs after the cache is cleared.
                // Remeasure them now, including rows whose text wrapped at the new width.
                (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-index]').forEach(row => virtualizer.measureElement(row));
            }
        });
        observer.observe(scrollElement);
        return () => observer.disconnect();
    }, [enabled, props.scrollRef, virtualizer]);
    if (!enabled)
        return React.createElement(React.Fragment, null, props.items.map(props.children));
    return React.createElement("div", { ref: contentRef, style: { height: virtualizer.getTotalSize(), position: 'relative', overflowAnchor: 'none' } }, virtualizer.getVirtualItems().map(row => (React.createElement("div", { key: props.getItemKey(row.index), "data-index": row.index, ref: virtualizer.measureElement, style: { position: 'absolute', top: 0, left: 0, width: '100%', display: 'flow-root', transform: `translateY(${row.start - scrollMargin}px)` } }, props.children(props.items[row.index], row.index)))));
}
